<template>
  <main v-loading="loading" class="mb-[20px]">
    <PointStatisticBlock :data="displayData" :shopPointKey="shopPointKey" />
  </main>
</template>

<script>
import PointStatisticBlock from '@/components/Report/PointStatisticBlock.vue'
import { FindMemberPointYearExpirations } from '@/api/shopPoint'
import store from '@/store'
import { computed, defineComponent, inject, onMounted, ref, watch } from 'vue'
import { map, get } from 'lodash'
import { formatDate } from '@/utils/date'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'PointStatistic',
  components: {
    PointStatisticBlock,
  },
  props: {
    memberId: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    shopPointKey: {
      type: String,
    },
    pointBalance: {
      type: Object,
    },
  },
  setup (props) {
    const pageShopPoint = inject('pageShopPoint')
    const data = ref([])
    const shopId = computed(() => store.getters.shop)
    const isBasic = computed(() => pageShopPoint.value.type === 'basic')
    // ?? 頁面顯示資料
    const displayData = computed(() => {
      let res = []
      if (isBasic.value) {
        res = map(data.value, (i) => {
          return {
            label: `${formatDate(i.expirationDate, 'YYYY/MM/DD')} ${t('member.tab.point.expiry')}`,
            value: i.balance,
          }
        })
      }
      res.unshift({
        label: `${t('member.tab.point.totalPrefix')}${get(pageShopPoint.value, 'name', t('member.tab.point.defaultName'))}`,
        value: get(props.pointBalance, `${props.shopPointKey}.balance`) ?? '-',
        showNegativeSign: true, // 所有積點類型均需顯示負數符號（CNCY-9295）
      })

      return res
    })

    // => 查詢會員點數到期資料
    const findMemberPointYearExpirations = async () => {
      const [res, err] = await FindMemberPointYearExpirations({
        shopId: shopId.value,
        memberId: props.memberId,
        shopPointKey: props.shopPointKey,
      })
      if (err) {
        window.$message.error(err)
        return
      }
      data.value = res
    }

    watch(props, async () => {
      if (props.loading && isBasic.value) await findMemberPointYearExpirations()
    })

    onMounted(() => {
      if (isBasic.value) findMemberPointYearExpirations()
    })

    return {
      data,
      displayData,
    }
  },
})
</script>

<style scoped lang="postcss"></style>
